import "../../assets/css/general/general.css"

import { Outlet } from "react-router-dom"

import WizardMenu from "../wizardMenu/wizardMenu.jsx"
import { useGeneralStates } from "../../context/general-context.jsx"

export default function General() {
    const { state, dispatch } = useGeneralStates();

    return (
        <main className="mainContainer">
            <Outlet />

            <WizardMenu state={state} dispatch={dispatch} />
        </main>
    )
}